import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_1121_3370)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.7924 6.60788L19.3339 0.000976562L13.2778 2.84058L14.9824 4.0051L11.4057 8.51692L9.99829 7.30824C8.87677 6.3451 7.17393 6.48167 6.22397 7.61095L0.973417 13.8527C0.505442 14.409 0.58207 15.2352 1.14457 15.698C1.70707 16.1608 2.54243 16.085 3.01041 15.5287L8.26097 9.287L9.66839 10.4957C10.8127 11.4784 12.5559 11.3134 13.491 10.1338L17.1666 5.49724L18.7924 6.60788Z",
        fill: "#4F4F4F"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_1121_3370" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "16",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }